import { render, staticRenderFns } from "./ProducerApprovalModal.html?vue&type=template&id=efe2b198&scoped=true&external"
import script from "./ProducerApprovalModal.ts?vue&type=script&lang=ts&external"
export * from "./ProducerApprovalModal.ts?vue&type=script&lang=ts&external"
import style0 from "./ProducerApprovalModal.css?vue&type=style&index=0&id=efe2b198&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe2b198",
  null
  
)

export default component.exports